import { z } from "zod";

export const formSchema = z.object({
    name: z.string().min(1, "forms.general-validation.name_required"),
    description: z.string(),
    is_active: z.boolean(),
    first_sequence_step_id: z.string().nullable(),

    types: z.array(z.string()).optional(),
    sources: z.array(z.string()).optional(),
    offer_ids: z.array(z.string()).optional(),
    excluded_offer_ids: z.array(z.any()).optional(),
    country_id: z.number().nullable().optional(),
    affiliate_ids: z.array(z.string()).optional(),
    advertiser_ids: z.array(z.string()).optional(),
});

export type IncomingPostbackFormData = z.infer<typeof formSchema>;
